module.exports = __webpack_public_path__ + "img/XLS.51e7ca93.svg";